/**
 * 特定の要素から指定したクラス以外のクラス名をターゲット要素にコピーするよ！
 * @param {HTMLElement} sourceElement - クラスをコピーする元の要素
 * @param {HTMLElement} targetElement - クラスをコピー先の要素
 * @param {string} excludeClass - 除外したいクラス名
 *
 * @example
 * // HTML: <div class="mw custom-class yahho"></div>
 * //      <div class="con"></div>
 * const wf = document.querySelector(".mw");
 * const parent = document.querySelector(".con");
 * copyClassesExcept(wf, parent, "mw");
 * // 結果: <div class="con custom-class yahho"></div>
 */
const copyClassesExcept = (sourceElement, targetElement, excludeClass) => {
    const classes = [...sourceElement.classList].filter(
        (className) => className !== excludeClass
    );

    targetElement.classList.add(...classes);
};

export const contactInit = () => {
    let rFunc = () => {};

    if (document.body.classList.contains("page-contact-0")) {
        const wf = document.querySelector(".mw_wp_form");
        const form = document.querySelector(".mw_wp_form form");
        const btn = document.querySelector(".con__formParts .Btn");
        const parent = document.querySelector(".con");

        copyClassesExcept(wf, parent, "mw_wp_form");

        if (form) {
            const trueBtn = form.querySelector(`input[type="submit"]`);
            btn.querySelector(".txt p").innerHTML = trueBtn.value;

            const btnOnClick = (e) => {
                e.preventDefault(); // デフォルトの動作を防止
                trueBtn.click();
            };
            btn?.addEventListener("click", btnOnClick);

            rFunc = () => {
                btn?.removeEventListener("click", btnOnClick);
            };
        }
    }
    return rFunc;
};

contactInit();
